import { apiRequest } from "./client";

export const adminApi = {
  overview() {
    return apiRequest("/admin/overview");
  },
  activity(params = {}) {
    return apiRequest("/admin/activity", { params });
  },
  activitySummary(hours = 24) {
    return apiRequest("/admin/activity/summary", { params: { hours } });
  },
  activityJourneys(params = {}) {
    return apiRequest("/admin/activity/journeys", { params });
  },
  pushStatus() {
    return apiRequest("/admin/push");
  },
  subscribePush(subscription, preferences = {}) {
    return apiRequest("/admin/push/subscribe", {
      method: "POST",
      body: JSON.stringify({ subscription, preferences }),
    });
  },
  unsubscribePush(endpoint) {
    return apiRequest("/admin/push/subscribe", {
      method: "DELETE",
      body: JSON.stringify({ endpoint }),
    });
  },
  testPush(payload = {}) {
    return apiRequest("/admin/push/test", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
};
